import { cn } from "@/lib/utils";
import Link from "@app/_components/Link";
import type { ComponentProps } from "react";

export default function ProductCardLink({
  className,
  ...props
}: ComponentProps<typeof Link>) {
  return <Link className={cn("no-underline", className)} {...props} />;
}

ProductCardLink.displayName = "ProductCardLink";
